export var getRenderPropValue = function getRenderPropValue(propValue) {
  if (!propValue) {
    return null;
  }

  var isRenderFunction = typeof propValue === 'function';

  if (isRenderFunction) {
    return propValue();
  }

  return propValue;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/getRenderPropValue.js
// module id = 890
// module chunks = 0